/* eslint-disable */
import { produce } from "immer";
import {
  BENEFICIARY_PATCH_FETCH_FAILURE,
  BENEFICIARY_PATCH_FETCH_SUCCESS,
  BENEFICIARY_PATCH_FETCH_START,
} from "../actions/types";

const addBeneficiaries = (
  state = {
    beneficiaryPatchFetching: false,
    beneficiaryPatchData: [],
    beneficiaryPatchError: null,
  },
  action,
) => {
  switch (action.type) {
    case BENEFICIARY_PATCH_FETCH_START:
      return produce(state, (draft) => {
        draft.beneficiaryPatchFetching = true;
      });
    case BENEFICIARY_PATCH_FETCH_SUCCESS:
      return produce(state, (draft) => {
        draft.beneficiaryPatchFetching = true;
        draft.beneficiaryPatchData = action.data;
        draft.beneficiaryPatchFetching = false;
      });
    case BENEFICIARY_PATCH_FETCH_FAILURE:
      return produce(state, (draft) => {
        draft.beneficiaryPatchFetching = false;
        draft.beneficiaryPatchError = action.error;
      });
    default:
      return state;
  }
};

export default addBeneficiaries;
